import React, { useEffect, useState } from "react";
import { getNotificationApi } from "../../../api/master.api";

const CaseNotification = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        getNotificationApi()
            .then(({ data: body }) => {
                const items = body?.data || {};
                const allData = [
                    ...(items.appeal || []),
                    ...(items.high || []),
                    ...(items.district || []),
                ];
                setData(allData);
            })
            .catch((err) => console.error(err));
    }, []);

    // 🖨️ Print Function
    const handlePrint = () => {
        const printContent = document.getElementById("print-section").innerHTML;
        const newWindow = window.open("", "", "width=900,height=700");

        newWindow.document.write(`
            <html>
                <head>
                    <title>Print Notifications</title>
                    <style>
                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                        th, td {
                            border: 1px solid #000;
                            padding: 8px;
                            text-align: left;
                        }
                    </style>
                </head>
                <body>
                    <h2>All Case Notifications</h2>
                    ${printContent}
                </body>
            </html>
        `);

        newWindow.document.close();
        newWindow.print();
    };

    return (
        <div className="page-wrapper">
            <div className="container my-4">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h3>All Notifications</h3>
                                <button className="btn btn-primary" onClick={handlePrint}>
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="print-section">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>SL</th>
                                <th>Case Number</th>
                                <th>Next Hearing Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.case_number}</td>
                                    <td>{item.next_hearing_date}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CaseNotification;